module.exports = __webpack_public_path__ + "static/media/icon_red.74edb909.svg";